import type { ReactNode } from 'react';
import { VStack } from '@astryxdesign/core/VStack';
import { Skeleton } from '@astryxdesign/core/Skeleton';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Button } from '@astryxdesign/core/Button';
import { Banner } from '@astryxdesign/core/Banner';
import { WifiSlash, WarningCircle } from '@phosphor-icons/react';

export function LoadingRows({ rows = 3, height = 64, label = 'Загрузка' }: { rows?: number; height?: number; label?: string }) {
  return (
    <VStack gap={2}>
      <span role="status" className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, i) => <Skeleton key={i} index={i} height={height} radius={3} width="100%" />)}
    </VStack>
  );
}

export function ErrorView({ error, onRetry, title = 'Не удалось загрузить' }: { error: unknown; onRetry?: () => void; title?: string }) {
  const offline = typeof navigator !== 'undefined' && !navigator.onLine;
  const message = error instanceof Error ? error.message : 'Попробуйте ещё раз.';
  return (
    <EmptyState
      title={offline ? 'Нет соединения' : title}
      description={offline ? 'Проверьте интернет и повторите.' : message}
      icon={offline ? <WifiSlash size={32} /> : <WarningCircle size={32} />}
      actions={onRetry ? <Button label="Повторить" variant="secondary" onClick={onRetry} /> : undefined}
      isCompact
    />
  );
}

export function Empty({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  return <EmptyState title={title} description={description} actions={action} isCompact />;
}

export function InlineError({ message }: { message: string }) {
  return <Banner status="error" title={message} container="card" />;
}
